module.exports = __webpack_public_path__ + "img/9788958076186.669b1c30.jpg";